import { FileItem } from '@aposin/ng-aquila/file-uploader';

export abstract class DocumentHandler {
  protected documents?: FileItem[];

  protected onFilesChange(files: FileItem[]) {
    this.documents = files;
  }

  protected onFileDeletion(file: FileItem) {
    const indexOfDocument = this.documents?.findIndex((d) => d.name === file.name);
    if (indexOfDocument !== undefined && indexOfDocument > -1) {
      this.documents?.splice(indexOfDocument, 1);
    }
  }
}
